module.exports = __webpack_public_path__ + "static/victor-51bb0b3a66a8a2323929aa4f1dd89c58.svg";